export const AUTH_ID: string = 'authId';
export const AUTH_ROLE: string = 'authRole';
export const AUTH_USERNAME: string = 'authUsername';
export const AUTH_IS_ALIAS: string = 'authIsAlias';
export const AUTH_ALIAS: string = 'authAlias';
export const AUTH_ALIAS_ID: string = 'authAliasId';
export const COMPANY_ID: string = 'companyId';
export const COMPANY_NAME: string = 'companyName';
export const COMPANY_UUID: string = 'companyUuid';
export const JWT: string = 'accessToken';
export const CHECK_LOGIN: string = 'EvoHuntChecker';
export const HIDE_GROUP_BANNER: string = 'hideGroupBanner';
